import { DataTypeLti } from '@efdigital/ll-admin-v2/data/data-types/lti';
import type { JsonApiDocument } from '@efdigital/ll-admin-v2/data/normalizers/jsonapi-document';
import type {
  ResourceLink,
  ResourceLinkListResponse,
} from '@efdigital/ll-cdk-lti-registration-api-types';

/** Cohort query response item — includes deployment context for update URLs. */
export type ResourceLinkQueryItem = ResourceLink & {
  platformId: string;
  consumedToolId: string;
  platformDeploymentId: string;
};

export type ResourceLinkQueryResponse = ResourceLinkQueryItem[];

function resourceLinkAttributes(link: ResourceLink) {
  return {
    consumedToolDeploymentId: link.consumedToolDeploymentId,
    platformResourceLinkId: link.platformResourceLinkId,
    toolItemType: link.toolItemType,
    toolItemId: link.toolItemId,
    isActive: link.isActive,
    createdAt: link.createdAt,
    updatedAt: link.updatedAt,
  };
}

function resourceLinkQueryAttributes(link: ResourceLinkQueryItem) {
  return {
    ...resourceLinkAttributes(link),
    platformId: link.platformId,
    consumedToolId: link.consumedToolId,
    platformDeploymentId: link.platformDeploymentId,
  };
}

export function resourceLinkToJsonApiResource(link: ResourceLink) {
  return {
    type: DataTypeLti.ResourceLink,
    id: link.id,
    attributes: resourceLinkAttributes(link),
  };
}

export function resourceLinkQueryItemToJsonApiResource(
  link: ResourceLinkQueryItem
) {
  return {
    type: DataTypeLti.ResourceLink,
    id: link.id,
    attributes: resourceLinkQueryAttributes(link),
  };
}

export function resourceLinkToJsonApiDocument(
  link: ResourceLink
): JsonApiDocument {
  return {
    data: resourceLinkToJsonApiResource(link),
  };
}

export function listResourceLinksResponseToJsonApiDocument(
  response: ResourceLinkListResponse
): JsonApiDocument {
  return {
    data: response.map(resourceLinkToJsonApiResource),
  };
}

export function listResourceLinksByCohortResponseToJsonApiDocument(
  response: ResourceLinkQueryResponse
): JsonApiDocument {
  return {
    data: response.map(resourceLinkQueryItemToJsonApiResource),
  };
}
